export default "__VITE_ASSET__49420197__"